import { addDefaults } from './types';
const sensitivityMap = {
  base: 'base',
  accent: 'accent',
  strict: 'variant'
};
export const createIntlComparator = (locale, options) => {
  const {
    toSortKey,
    direction,
    sensitivity
  } = addDefaults(options);
  const intlSensitivity = sensitivityMap[sensitivity];
  const comparator = new Intl.Collator(locale, {
    sensitivity: intlSensitivity
  }).compare;
  return (first, second) => {
    const firstKey = toSortKey(first);
    const secondKey = toSortKey(second);
    let result = 0;
    if (firstKey === secondKey) {
      result = 0;
    } else if (secondKey === null) {
      result = -1;
    } else if (firstKey === null) {
      result = 1;
    } else if (typeof firstKey === 'number' && typeof secondKey === 'number') {
      result = firstKey - secondKey;
    } else {
      // Coerce (string | number) to just string.
      result = comparator(`${firstKey}`, `${secondKey}`);
    }
    return direction === 'descending' ? -1 * result : result;
  };
};
//# sourceMappingURL=createIntlComparator.js.map